import React from "react";
import FrontPage from "../../../Components/FrontPage/FrontPage";
import { useAuth } from "../../../providers/AuthProvider";

export default () => {
  const { referrer, setReferrer } = useAuth();

  const navigateAfterLogin = (loginResult) => {
    if (referrer) {
      setReferrer(null);
      document.location.href = referrer;
      return;
    }

    /* FIXME: We should rely on the server redirect if present, but we can't
              currently depend on it having a sane value. It may work tho, but
              need testing. Make sure we never redirect to api routes because of
              failed login
    if (loginResult?.redirect) {
      document.location.href = loginResult.redirect;
      return;
    }
    */

    document.location.href = "/sections/packages/";
  };

  const handleLoginSuccess = (loginResult) => {
    navigateAfterLogin(loginResult);
  };

  const handleLoginSuccessNewCode = (loginResult) => {
    navigateAfterLogin(loginResult);
  };

  return (
    <FrontPage
      handleLoginSuccess={handleLoginSuccess}
      handleLoginSuccessNewCode={handleLoginSuccessNewCode}
    />
  );
};
